import axios from "axios";
import { baseURL } from "../globals/constants";
import { showErrorToast } from "../utils/Toast";

const headers = () => ({ headers: { Accept: "application/json", Authorization: `Bearer ${localStorage.getItem("access_token")}` } });

export interface VideoJobSummary {
  queued: number;
  processing: number;
  done: number;
  failed: number;
  latest: { id: string; status: string; source: string; attempts: number; durationSeconds?: number; error: string; updatedAt: string; url: string }[];
  /** Remote converters (Grete): seen within the last two minutes = online */
  agents?: { name: string; encoder?: string; gpu?: string; jobsDone: number; lastSeenAt: string; online: boolean }[];
  agentEnabled?: boolean;
}

export const getVideoJobs = async (): Promise<VideoJobSummary | null> => {
  try {
    return (await axios.get(`${baseURL}/v1/videos/jobs`, headers())).data;
  } catch {
    return null;
  }
};

export const convertExistingVideos = async (): Promise<{ queued: number; alreadyConverted: number } | null> => {
  try {
    return (await axios.post(`${baseURL}/v1/videos/convert-existing`, {}, headers())).data;
  } catch (error: any) {
    showErrorToast(error?.response?.data?.message || "Could not start the conversion", false);
    return null;
  }
};

export const retryVideoJob = async (jobId: string) => {
  try {
    return (await axios.post(`${baseURL}/v1/videos/jobs/${jobId}/retry`, {}, headers())).data;
  } catch (error: any) {
    showErrorToast(error?.response?.data?.message || "Could not retry", false);
    return null;
  }
};
